import { put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { IPatientVitals } from '../store/vitals.types'
import { setShockIndex } from '../store/vitals.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { IDataPointsConfig } from '../../configurations/store/configurations.types'
import { getDatapointsConfigSelector } from '../../configurations/selectors'

export function* setCalculatedShockIndex() {
  const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)
  const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
  const { DP_SHOCK_INDEX } = datapointsConfig
  if (DP_SHOCK_INDEX === 1 || (DP_SHOCK_INDEX === 0 && patientVital?.shockIndex)) {
    const { heartRate, systolicBP, heartRatePNNV, systolicBPPNNV } = patientVital
    if (heartRate && systolicBP && parseInt(systolicBP) > 0) {
      const shockIndex = (parseInt(heartRate) / parseInt(systolicBP)).toFixed(2)
      yield put(setShockIndex(shockIndex))
    }
    if (heartRatePNNV || systolicBPPNNV) {
      yield put(setShockIndex(''))
    }
  }
}

export function* setCalculatedShockIndexSaga() {
  yield takeLatest(
    [
      VitalsConstants.SET_HEART_RATE,
      VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE,
      VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE_PNNV,
      VitalsConstants.SET_HEART_RATE_PNNV,
    ],
    performWithMutexHOG,
    setCalculatedShockIndex
  )
}
